import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMoreButtonText: {
		id: 'software-releases-version-detail.version-description.show-more-button-text',
		defaultMessage: 'Show More',
		description: 'Text for a button to show the full version description',
	},
	showLessButtonText: {
		id: 'software-releases-version-detail.version-description.show-less-button-text',
		defaultMessage: 'Show Less',
		description: 'Text for a button to hide the full version description',
	},
	descriptionHeader: {
		id: 'software-releases-version-detail.version-description.description-header',
		defaultMessage: 'Description',
		description: 'Text for he header of the version description field',
	},
});
